import clsx from 'clsx';
import * as React from 'react';

interface Props {
  body: React.ReactNode;
  close: () => void;
}

function ModalBody({ body, close }: Props) {
  return (
    <div
      className={clsx(
        'absolute flex w-40 flex-col border bg-white text-sm',
        'bottom-12 right-0 rounded-md border-solid border-gray-300 text-gray-800',
      )}
      onMouseUp={() => setTimeout(close, 100)}
    >
      {body}
    </div>
  );
}

export default ModalBody;
